package com.essntl.features.itinerary.domain.model

data class ItineraryServiceFilterOptions(
    val selectedItineraryServiceOrderType: ItineraryServiceOrderType = ItineraryServiceOrderType.Default,
)